import deepMerge from "./deepMerge";
import theme from "../constants/theme";

const configureTheme = (themeVariable, tdsId) => {
  let clientTheme = window[themeVariable];
  let mergedTheme;

  if (clientTheme !== undefined) {
    mergedTheme = deepMerge(theme, clientTheme);
  } else {
    mergedTheme = { ...theme };
  }

  mergedTheme.tdsId = tdsId;

  return mergedTheme;
};

export default configureTheme;
